/* SLIDE 5 */

import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import parkingStatusIcon from "assets/icons/parkingstatus.svg";


import { useNavigate } from "react-router-dom";

const ListPage = () => {
  const { showMenu } = useSelector((state) => state.header);
  const [isManager, setIsManager] = useState(true);
  const navigation = useNavigate();

  const onNavi = (path) => {
    navigation(path);
  };

  const slides = [
    {name: "Slide 1,2,3", path: "/"},
    {name: "Slide 4", path: "/reset_password"},
    {name: "Slide 5,6", path: "/menu_manager"},
    {name: "Slide 7,8,9", path: "/parking_status"},
    {name: "Slide 10,11", path: "/parking_status2"},
    {name: "Slide 12", path: "/parking_setting"},
    {name: "Slide 13", path: "/parking_status_additional"},
    {name: "Slide 14,15", path: "/parking_spot_setting"},
    {name: "Slide 16", path: "/parking_setting2"},
    {name: "Slide 17,18,19", path: "/parking_spot_setting"},
    {name: "Slide 20,21, 22", path: "/parking_check"},
    {name: "Slide 23", path: "/parking_check_result"},
    {name: "Slide 24", path: "/parking_check_success"},
    {name: "Slide 25", path: "/parking_check"},
    {name: "Slide 26,27,31,32", path: "/parking_payment"},
    {name: "Slide 33", path: "/parking_payment_success"},
    {name: "Slide 34", path: "/parking_payment_complete"},
    {name: "Slide 35", path: "/parking_payment_pending"},
    {name: "Slide 36", path: "/parking_unpaid_list"},
    {name: "Slide 39", path: "/parking_payment_empty"},
    {name: "Slide 40", path: "/parking_setting_list"},
    {name: "Slide 41,42,43,44", path: "/parking_add_form"},
    {name: "Slide 46,47,48,49,50", path: "/time_attendance"},
    {name: "Slide 51,60", path: "/schedule_management"},
    {name: "Slide 52,53,54", path: "/schedule_setting"},
    {name: "Slide 55", path: "/parking_calendar"},
    {name: "Slide 58,59,62", path: "/parking_detail_attendance"},
    {name: "Slide 57", path: "/parking_attendance"},
    {name: "Slide 65", path: "/parking_detail_attendance"},
    {name: "Slide 56", path: "/daily_schedule"},
    {name: "Slide 66,67,68", path: "/user_manager"},
    {name: "Slide 69,70,71", path: "/user_manager_edit"},
    {name: "Slide 72,37", path: "/user_address_manager"},
    {name: "Slide 74,75", path: "/user_address_manager_edit"},
    {name: "Slide 76", path: "/parking_settlement"},
    {name: "Slide 77,78", path: "/parking_detail_settlement"},
    {name: "Slide 63,64", path: "/parking_workday_book"},
    {name: "Slide 65", path: "/parking_workday_attendance"},
  ]

  return (
    <div className="employee-management-container">
      {showMenu && (
        <>
          <div className="menu-section">
            
            <div className="menu-title">근무자 메뉴</div>

            <div className="menu-grid">
                {slides.map((slide, index) => (
                  <div
                    key={index}
                    className="menu-item"
                    onClick={() => onNavi(slide.path)}
                  >
                    <div className="icon">
                      <img src={parkingStatusIcon} alt="parking Status" />
                    </div>
                    <div className="label">{slide.name}</div>
                  </div>
                ))}
             
            </div>
          </div>
        
        </>
      )}
    </div>
  );
};

export default ListPage;
